/**
 * @author      autogenerated
 * @copyright   Copyright (c) 2025, Zumper
 * @description FeeCadence
 */

/** enum value represents fee per approximate days */
export enum FeeCadence {
  ONE_TIME = 0,
  MONTHLY = 30,
  QUARTERLY = 90,
  SEMIANNUALLY = 180,
  ANNUALLY = 365,
}

Object.defineProperty(FeeCadence, '__ENUM_NAME', {
  value: 'FeeCadence',
  writable: false,
  configurable: false,
  enumerable: false,
})
